import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { injectIntl, IntlProvider } from 'react-intl';
import { changeLocale, logoutCompleted, updateDefaultCollectionLabel, validateSURL } from '../actions/session';
import * as sessionStateTypes from '../constants/sessionStateTypes';
import messagesFR from '../../translations/fr';
import messagesEN from '../../translations/en';
import { resetConfig } from '../appConfig';
import {
  LOCAL_STORAGE_CSRF_TOKEN,
  LOCAL_STORAGE_EXT_SEARCH,
  LOCAL_STORAGE_LOCALE_KEY,
  LOCAL_STORAGE_SURL_KEY,
} from '../constants/session';
import Loader from '../components/ui/Loader';
import Login from './Login';
import Main from './Main';
import UMOView from './UMOView';
import ExternalLogin from './ExternalLogin';
import { getUrlVars } from '../utils/uiUtils';

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/locale-data/de'); // Add locale data for de
}

const messages = {
  fr: messagesFR,
  en: messagesEN,
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  changeLocale: (locale) => {
    dispatch(changeLocale(locale));
  },
  validateSURL: (surl, token, surlCookie) => {
    dispatch(validateSURL(surl, token, surlCookie, true));
  },
  logoutCompleted: () => {
    dispatch(logoutCompleted());
  },
  updateDefaultCollectionLabel: (label) => {
    dispatch(updateDefaultCollectionLabel(label));
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    if (props.session.get('sessionState') === sessionStateTypes.INITIALISED) {
      const surl = sessionStorage.getItem(LOCAL_STORAGE_SURL_KEY);
      const csrf = sessionStorage.getItem(LOCAL_STORAGE_CSRF_TOKEN);
      props.validateSURL(surl, csrf, (csrf && !surl));
    }

/*    const storedLocale = sessionStorage.getItem(LOCAL_STORAGE_LOCALE_KEY);
    if (storedLocale) {
      props.changeLocale(storedLocale);
      setLocale(storedLocale);
      props.updateDefaultCollectionLabel(
        messages[storedLocale]['searchBar.advanced.defaultCollectionLabel']
      );
    }*/

    window.history.pushState(null, null, null);
    $(window).on('popstate', (event) => {
      if (!event.originalEvent.state) {
        window.history.pushState(null, null, null);
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.session.get('sessionState') !== this.props.session.get('sessionState')) {
      switch (this.props.session.get('sessionState')) {
        case sessionStateTypes.SESSION_TIMEOUT:
        case sessionStateTypes.LOGGED_OUT:
          sessionStorage.removeItem(LOCAL_STORAGE_SURL_KEY);
          sessionStorage.removeItem(LOCAL_STORAGE_CSRF_TOKEN);
          resetConfig();
          break;
        case sessionStateTypes.LOGGED_IN:
          if (!this.props.session.get('surlCookie')) sessionStorage.setItem(LOCAL_STORAGE_SURL_KEY, this.props.session.get('surl'));
          sessionStorage.setItem(LOCAL_STORAGE_CSRF_TOKEN, this.props.session.get('token'));
          sessionStorage.setItem(LOCAL_STORAGE_LOCALE_KEY, this.props.session.get('locale'));
          break;
        default:
          break;
      }
    }
  }

  render() {
    const { session } = this.props;
    // if a umo id is sent in the url, use it instead of an external search
    if (window.location.href.search('umo=') !== -1) {
      sessionStorage.setItem(LOCAL_STORAGE_EXT_SEARCH, `UMO_ID:"${getUrlVars().umo}"`);
    }
    // login elements to consider in path calculation
    const sessionState = session.get('sessionState');
    const isAuth = sessionState === sessionStateTypes.LOGGED_IN;
    const isValidatingSession = sessionState === sessionStateTypes.REQUESTING_VALIDATION ||
      sessionState === sessionStateTypes.INITIALISED;

    // including extra login elements- public user or external login and set the url path
    const publicUsr = (session.get('publicUsr') && session.get('username')) || getUrlVars().usr;

    // external login is not used in this area, leaving in case issues when removed
    const loginPath = '/login'; // session.get('extLogin') ? '/external' : '/login';
    const homePath = publicUsr ? `/home?usr=${publicUsr}` : '/home';

    return (
      <IntlProvider
        locale={session.get('locale')}
        messages={messages[session.get('locale')]}
      >
        <div className="app-wrapper">
          {isValidatingSession ? <Loader isLarge wrapperClass="app-loading-wrapper" /> :
              <Redirect to={isAuth ? homePath : loginPath} />}
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/umo/:umoID" component={UMOView} />
            <Route path="/home" component={Main} />
            <Route path="/external" component={ExternalLogin} />
          </Switch>
        </div>
      </IntlProvider>
    );
  }
}

App.contextTypes = {
  router: PropTypes.object,
};

App.propTypes = {
  children: PropTypes.node,
  validateSURL: PropTypes.func,
  changeLocale: PropTypes.func,
  updateDefaultCollectionLabel: PropTypes.func,
  session: PropTypes.instanceOf(Map),
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/js/components/App.jsx